import { RavelElement } from '../../../base/ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';
import { RavelEmoji } from '../../../../../modules/RavelEmoji.js';

export class RavelSwitch extends RavelElement {
    static get localStyles() {
        return `
        <style>
        #container {
            position: absolute;
            cursor: pointer;
        }
        #switch-wrapper {
            display: flex;
            flex: space-between;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            padding: 5px;
            border: 5px solid #444444;
        }
        .switch {
            position: relative;
            background-color: #999999;
            height: 100%;
            width: 20px;
            margin: 1px;
        }
        .switch .active {
            box-shadow: inset 0px 0px 4px 4px rgba(255, 255, 255, .25);
        }
        .switch-shadow {
            position: absolute;
            bottom: 0px;
            width: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            height: 20%;
        }
        .selected {
            -webkit-box-shadow: 0px 0px 0px 10px rgba(255, 255, 0, 0.5); 
            box-shadow: 0px 0px 0px 10px rgba(255, 255, 0, 0.5);
            background-color: rgba(255, 255, 0, 0.5);
            border-radius: 14px;
        }
        </style>
        `;
    }
  
    static get html() { 
        return `
        <div id="container">
        <div id="switch-wrapper">
        </div>
        </div>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 
            'type', 'orientation', 'states', 'state', 'color', 'signals', 'w', 'h'];
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html
            + this.constructor.baseStyles
            + this.constructor.baseHtml;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        this.container = this.shadowRoot.querySelector('#container');
        this.switchId = 0;
        this.type = 'toggle';
        this.size = '50';
        this.orientation = 'horizontal';
        this.states = 2;
        this.state = 1;
        this.stateDir = 1;
        this.signals = [ ];
        this.noClick = false;
        this.showFeedback = false;
        this.x = 0;
        this.y = 0;
        this.width = 100;
        this.height = 100;
        this.switchWidth = 50;
        this.offColor = '#999999';
    }
  
    setup = () => {
        this.observedMessages = [`${this.id}`];
        this.subscribe(this.observedMessages);
        this.container.style.width = `${this.width}px`;
        this.container.style.height = `${this.height}px`;
        this.container.style.top = `${this.y}px`;
        this.container.style.left = `${this.x}px`;
        this.switchWidth = this.width / this.states;
        console.log(this.width);

        let wrapper = this.shadowRoot.querySelector('#switch-wrapper');
        let widthAttribute = `${this.switchWidth}px`;
        if (this.orientation === 'vertical') {
            wrapper.style.flexDirection = 'column';
            widthAttribute = '100%';
        }

        for (let i = 1; i <= this.states; i++) {
            wrapper.innerHTML = wrapper.innerHTML + `
                <div id="state-${i}" class="switch" style="width:${widthAttribute};"><div class="switch-shadow"></div><div>`;
        }
        this.shadowRoot.querySelector(`#state-${this.state}`).style.backgroundColor = this.color;
        this.addEventListener('click', this.handleToggle);
        this.addEventListener('toggle', this.handleToggle);

        this.addEventListener(`${this.id}`, this.handleEvent);
        this.broadcastMessage('register-sensor', this.id, this.container);
        //this.broadcastMessage('register-sensor', this.id, { x: this.x + this.width/2, y: this.y + this.height/2 + 10, w: this.width, h: this.height });
    }
    
    handleToggle = () => {
        this.shadowRoot.querySelector(`#state-${this.state}`).style.backgroundColor = this.offColor;
        if ((this.state === this.states) || ((this.state === 1) && (this.stateDir === -1))) {
            this.stateDir = this.stateDir * -1;
        }
        this.state =  this.state + this.stateDir;
        console.log(this.state);
        this.shadowRoot.querySelector(`#state-${this.state}`).style.backgroundColor = this.color; 
        this.sendMessage(this.stateSignals[this.state - 1 ], '', '');
        let evt = new CustomEvent(this.stateSignals[this.state], { detail: {}});
        this.dispatchEvent(evt);
    }
    
    handleEvent = (e) => {
        e.preventDefault();
        const type = e.detail.cmd;
        console.log(type);
        if (type === 'select') {
            this.shadowRoot.querySelector('#switch-wrapper').classList.add('selected');
        }
        if (type === 'unselect') {
            this.shadowRoot.querySelector('#switch-wrapper').classList.toggle('selected');
        }
        if (type === 'virtual-click') {
            this.handleToggle();
        }
    }

    teardown = () => {
        this.unsubscribe(this.observedMessages);
        this.broadcastMessage('register-sensor', this.id);
    }

    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'w') {
            this.width = Number(newValue);
        }
        if (name === 'h') {
            this.height = Number(newValue);
        }
        if (name === 'orientation') {
            this.orientation = newValue;
        }
        if (name === 'type') {
            this.type = newValue;
        }
        if (name === 'states') {
            this.states = parseInt(newValue, 10);
        }
        if (name === 'state') {
            this.state = parseInt(newValue, 10);
        }
        if (name === 'color') {
            this.color = newValue;
        }
        if (name === 'signals') {
            this.stateSignals = newValue.split(',');
        }
        if (name === 'no-click') {
            this.noClick = true;
        }
        if (name === 'show-feedback') {
            this.showFeedback = true;
        }
    }
}

